import { routes } from './routes';

// Flat primary nav for the top app-bar (<TopNav>). No roles, no sections —
// FieldPro is flat-grower auth; the server scopes resources.
//
// Text only: the Figma app bar (node 232:350877) renders the labels with an active-state
// underline and carries no icons, so there is no icon field to keep in sync.
export type NavItem = {
  key: string;
  label: string;
  to: string;
};

export const nav: NavItem[] = [
  { key: 'map', label: 'Map', to: routes.map },
  { key: 'devices', label: 'Devices', to: routes.devices },
];
